<template>
  <div class="panel panel-default">
    <!-- Default panel contents -->
    <div class="panel-heading">Tabela de Inscritos</div>

    <!-- Table -->
    <table class="table table-striped table-hover table-condensed table-responsive">
      <thead>
        <tr>
          <th class="text-center">Dorsal</th>
          <th class="text-left">Nome</th>
          <th class="text-center">Equipa</th>
          <th class="text-center">TS</th>
          <th class="text-center">Ac</th>
          <th class="text-center">Valor</th>
          <th class="text-center">Estado</th>
          <th class="text-right">Opções</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="participante in lista" :key="participante.id">
          <td class="text-center">{{ participante.dorsal }}</td>
          <td class="text-left">{{ participante.nome }}</td>
          <td class="text-center">{{ participante.equipa }}</td>
          <td class="text-center">{{ participante.tamanho }}</td>
          <td class="text-center">{{ participante.acompanhantes }}</td>
          <td class="text-center">{{ participante.valor }}</td>
          <td class="text-center warning" v-if="!participante.confirmacao && !participante.anulado">Pendente</td>
          <td class="text-center success" v-if="participante.confirmacao && !participante.checkin">Validado</td>
          <td class="text-center primary" v-if="participante.checkin">Entregue</td>
          <td class="text-center danger" v-if="participante.anulado">Anulado</td>
          <td class="text-right">
            <div class="btn-group btn-group-xs" role="group">
              <button class="btn btn-default" @click="this.valida(participante)" v-if="!participante.confirmacao && !participante.anulado">
                <span class="glyphicon glyphicon-ok" aria-hidden="true"></span>
              </button>
							<button class="btn btn-default" @click="this.reenvia(participante)" v-if="!participante.confirmacao && !participante.anulado">
                <span class="glyphicon glyphicon-share-alt" aria-hidden="true"></span>
              </button>
              <button class="btn btn-default" @click="this.checkin(participante)" v-if="participante.confirmacao">
                <span class="glyphicon glyphicon-flag" aria-hidden="true"></span>
              </button>
              <button class="btn btn-default" @click="this.anula(participante)" v-if="participante.confirmacao && !participante.anulado">
                <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
              </button>
              <button class="btn btn-default" @click="this.apaga(participante)" v-if="!participante.confirmacao && !participante.anulado">
                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TabelaPendentes',
  props: [
    'lista'
  ],
  methods: {
    valida () {

    },
    reenvia () {

    },
    checkin () {

    },
    anula () {

    },
    apaga () {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// TabelaInscritos.vue?ac4d3550